<template>
  <o-dialog
    ref="dialog"
    :title="$t('reservation.confirmCustomer')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  >
    <div class="pt-4 text-left">
      <o-field-group>
        <checkbox-field v-model="sendMail" :label="$t('general.sendEmail')" :info="$t('reservation.sendEmailInfo')" />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import {
  CheckboxField,
} from '@/components/fields'

interface Props {
  reservation: any
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'update:reservation', value: any): void
  (e: 'update'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $auth } = useNuxtApp()

const dialog = ref<any>()
const sendMail = ref(false)

const info = computed(() => {
  return $i18n.t('components.reservationCustomer.actions.confirm.info', { name: props.reservation?.customer.displayName })
})

const open = () => {
  sendMail.value = ($auth as any).info?.location?.sendInternalReservationConfirmNotifications

  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.reservationCustomer.confirm(
      props.reservation.objectID(),
      { sendEmail: sendMail.value }
    )

    if (response.data) {
      emit('update:reservation', response.data)
      emit('update:loading', false)
      emit('update')

      $notification.toast({
        title: $i18n.t('reservation.confirmed'),
        text: $i18n.t('reservation.confirmSuccessInfo', { name: props.reservation?.customer.displayName }),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)
  }
}

defineExpose({
  open,
})
</script>
